/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import Vue from 'vue';

const WIKI_URL = 'https://reciprocitylabs.atlassian.net/wiki/';
// Confluence page source of truth for links:
// https://reciprocitylabs.atlassian.net/wiki/x/XICyCw
const LINKS: any = {
  '/export': 'x/oADiBg',
  '/export/surveys': 'x/BADFB',
  '/import': 'x/jYDmB',
  '/jira/settings': 'x/uABPB',
  '/my_dashboard/todo': 'x/BwChBQ',
  '/people': 'x/FwCYBg',
  '/reporting_dashboard': 'x/CoB-AQ',
  '/reports/audits/': 'x/EoCTB',
  '/reports/audits/wizard': 'x/D4BkB',
  '/reports/audits/wizard/new': 'x/CwB0B',
  '/reports/audits/wizard/edit/[0-9]+/1': 'x/CwB0B',
  '/reports/audits/wizard/edit/[0-9]+/2': 'x/CYB2B',
  '/reports/audits/wizard/edit/[0-9]+/3': 'x/iQCQB',
  '/reports/audits/wizard/edit/[0-9]+/4': 'x/BIB1B',
  '/reports/audits/wizard/edit/[0-9]+/5': 'x/BICTB',
  '/risk_heatmap': 'x/9QApCg',
  '/servicenow/': 'x/GgD8F',
  '/settings/custom_attributes': 'x/NADxDw',
  '/settings/notifications': 'x/QADJBQ',
  '/settings/saml_settings': 'x/YAB5HQ',
  '/settings/risk': 'x/goCWJw',
  '/settings/risk/heatmap': 'x/UQWONg',
  '/settings/risk/tasks': 'x/WoAfMQ',
  '/settings/system_settings': 'x/SAAyFQ',
  '/sor_setup/program_onboarding': 'x/OxAVB',
  '/sor_setup/scoping/': 'x/iRkXB',
  '/sor_setup/input_options/': 'x/NRAVB',
  '/sor_setup/import_controls/': 'x/NRAVB',
  '/sor_setup/mapping/': 'x/NRAVB',
  '/sor/listing/revision': 'x/NIDbDg',
  '/sor/listing/surveyTemplate': 'x/BADFB',
  '/sor/listing/task': 'x/GQBNFQ',
  '/sor/listing/tagInfo': 'x/VoAwFQ',
  '/sor/listing/vendor': 'x/GADMB',
  '/sor/listing/': 'x/1YDaB',
  '/storage/integrations': 'x/OwCfEg',
  '/survey_sending/new': 'x/BADFB',
  '/todo_list/': 'x/BwChBQ',
  '/todo-list/': 'x/TABPM',
  '/workflows': 'x/bAA8Rg',
};

export default Vue.extend({
  functional: true,
  render(createElement) {
    // Take the keys (urls) and sort them by descending length,
    // so that more specific (longer) urls take priority
    const target = Object.keys(LINKS)
      .sort((a, b) => b.length - a.length)
      .find(page => {
        const regex = new RegExp(page, 'i');
        return regex.test(location.pathname);
      });

    if (!target) {
      return null;
    }

    return createElement(
      'a',
      {
        class: {
          'help-link': true,
        },
        attrs: {
          href: WIKI_URL + LINKS[target],
          target: '_blank',
          title: 'Open wiki page for this feature',
        },
      },
      [createElement('i', { class: { 'fa fa-question-circle': true } })]
    );
  },
});
